import { StyledContainerNoWidth } from "./styles";
import { ContainerProps } from "../types";

const ContainerNoWidth = ({ border, children }: ContainerProps) => (
  <StyledContainerNoWidth border={border}>{children}</StyledContainerNoWidth>
);

export default ContainerNoWidth;
